import React from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import { FILTER_GENDER } from 'dpl/constants/query_params';
import InputCard from 'dpl/common/design_system/InputCard';

export default function GenderFilter() {
  const queryParams = useSelector(state => state.queryParams);
  const { genderOptions } = useSelector(({ server }) => server);
  const dispatch = useDispatch();

  function handleFilterChange(e) {
    const { value } = e.target;
    const paramValue = queryParams[FILTER_GENDER];
    const genderFilterValues = genderOptions.map(go => go.value);
    const oppositeValue = genderFilterValues.find(v => v !== value) || '';

    if (paramValue === 'any') {
      dispatch(pushParams({ [FILTER_GENDER]: oppositeValue }, { hash: true }));
    } else if (paramValue === value) {
      dispatch(resetParams(FILTER_GENDER, { hash: true }));
    } else if (paramValue === oppositeValue) {
      dispatch(pushParams({ [FILTER_GENDER]: 'any' }, { hash: true }));
    } else {
      dispatch(pushParams({ [FILTER_GENDER]: value }, { hash: true }));
    }
  }

  function isSelected(opt) {
    const paramValue = queryParams[FILTER_GENDER];
    if (!paramValue) {
      return false;
    }
    if (paramValue === 'any' || opt.value === paramValue) {
      return true;
    }
    return false;
  }

  return (
    <>
      <p className="mb4 font-16 fw-medium md:font-18 md:font-serif">Gender</p>
      <div className="SearchResultFiltersGenderFilter flex">
        {genderOptions.map((opt, idx) => (
          <div
            key={opt.value}
            className={classnames('SearchResultFiltersGenderFilter__option', {
              mr2: idx === 0
            })}
          >
            <InputCard
              className={classnames('ba ph4 pv4', {
                'b--default': !isSelected(opt),
                'b--midnight': isSelected(opt)
              })}
              type="checkbox"
              icon={{
                className: 'bg-pale-blue midnight ph2 pv2',
                name: opt.value,
                size: '20'
              }}
              inputProps={{
                name: `${FILTER_GENDER}_${opt.value}`,
                value: opt.value,
                onChange: handleFilterChange
              }}
            >
              <div className="font-16 lh-1 mt6">{opt.title}</div>
            </InputCard>
          </div>
        ))}
      </div>
    </>
  );
}
